<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">

    <mat-card class="login-form">

        <mat-card-header>

            <div style="width: 100%;">
                <img class="login-logo" src="../../../assets/img/login_logo.png" />

            </div>

        </mat-card-header>


        <!-- <div *ngIf="showPasswordResetProgressSpinner" class="spinner-wrapper">
            <mat-spinner class="spinner-inner"></mat-spinner>
        </div> -->


        <div style="display: flex; justify-content: center; margin: 32px;">
            <p style="display: {{'es' | translate}};color: red; font-size: 18px">
                El pedido se ha cancelado y no se ha procesado el pago.
            </p>
            <p style="display: {{'cat' | translate}};color: red; font-size: 18px">
                La comanda s'ha cancel·lat i no s'ha processat el pagament.
            </p>
            <p style="display: {{'en' | translate}};color: red; font-size: 18px">
                The order has been canceled and no payment has been made.
            </p>
        </div>


        <div>
            <button mat-flat-button class="backButton" [ngClass]="{'success': success}" routerLink="/orders">
                <mat-icon>arrow_back</mat-icon>
                <span>&nbsp; {{'buttons.return' | translate}}</span>
            </button>
        </div>
    </mat-card>

</div>